module.exports = __webpack_public_path__ + "static/media/instagram.fbbc6075.svg";